
export class DecadenceStatics {

    public static SYMBOL_WIDTH:number = 144;
    public static SYMBOL_HEIGHT:number = 144;

    public static REEL_X_OFFSET:number = DecadenceStatics.SYMBOL_WIDTH;

    public static STEP_WIDTH:number = DecadenceStatics.SYMBOL_WIDTH * 0.5;
    public static STEP_HEIGHT:number = DecadenceStatics.SYMBOL_HEIGHT * 0.5;

    public static REEL_AREA_X_OFFSET:number = 114;
    public static REEL_AREA_Y_OFFSET:number = 114;

    public static GAME_ELEMENTS_PORTRAIT_OFFSET:number = -100;

    // Reel spin

    public static spinStartOffset:number = 0.2;
    public static spinStartOffsetFastSpin:number = 0.1;

    public static spinStepDuration:number = 0.034;
    public static reelStopDelay:number = 0.40;
    public static reelStopDelayFastSpin:number = 0.15;

    public static SYMBOLS_BASE_SCALE:{[key:string]:number} = {
        "0": 1,
        "-": 1,
        "1": 0.8,
        "2": 0.8,
        "5": 0.8,
        "10": 0.85,
        "25": 0.85,
        "50": 0.85,
        "100": 0.9,
        "250": 0.9,
        "500": 0.9,
        "1000": 1,
        "10000": 1,
    };

    public static DEFAULT_REEL_SET:string[] = [
        "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0",
        "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1",
        "2", "2", "2", "2", "2", "2", "2", "2", "2", "2",
        "5", "5", "5", "5", "5", "5",
        "10", "10", "10", "10",
        "100",
        "250",
        "500",
        "1000",
        "10000",
        "SC"
    ];

    public static REEL_SET_BOOSTER_2_REELS:string[] = [
        "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0",
        "2", "2", "2", "2", "2", "2", "2", "2", "2", "2",
        "5", "5", "5", "5", "5", "5",
        "10", "10", "10", "10",
        "100",
        "250",
        "500",
        "1000",
        "10000",
        "SC"
    ];

    public static REEL_SET_BOOSTER_4_REELS:string[] = [
        "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0",
        "5", "5", "5", "5", "5", "5",
        "10", "10", "10", "10",
        "100",
        "250",
        "500",
        "1000",
        "10000",
        "SC"
    ];


    public static GOD_MODE_REEL_SET:string[] = [
        "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "10000", "0", "0", "0", "0", "0", "0", "0", "0", "0",
    ];

    public static getReelSetFromMode(mode:string):string[] {
        switch (mode) {
            case "FREESPIN_REELS_2":
            case "SUPER_FREESPIN_REELS_2":
            case "REELS_2": return DecadenceStatics.REEL_SET_BOOSTER_2_REELS;

            case "FREESPIN_REELS_4":
            case "SUPER_FREESPIN_REELS_4":
            case "REELS_4": return DecadenceStatics.REEL_SET_BOOSTER_4_REELS;

            case "GOD_MODE": return DecadenceStatics.GOD_MODE_REEL_SET;
            default: return DecadenceStatics.DEFAULT_REEL_SET;
        }
    }

    constructor() {

    }

}


